import { atom } from 'jotai';

/**
 * Atom to store and manage the current sales mode state
 * Defaults to false as the initial value
 */
export const isSalesModeAtom = atom(false);
